// Site-wide Escape key: closes whatever is "open" on the current page, one thing per
// press (a card, a dossier, a point of view, a search...). Pages register a handler
// that closes one thing and returns true, or returns false if nothing was open.
// Pop-ups (Oruga modals) close themselves on Escape, so they're left to it.

const handlers = [];

window.addEventListener("keydown", e => {
	if (e.key !== "Escape" || e.defaultPrevented) return;
	if (document.querySelector(".o-modal")) return;
	// Newest first, so the page you're on wins
	for (let i = handlers.length - 1; i >= 0; i--) {
		if (handlers[i]()) {
			e.preventDefault();
			// Typing in a search box? Let Escape leave it too
			if (document.activeElement?.blur && document.activeElement.matches?.("input, textarea"))
				document.activeElement.blur();
			return;
		}
	}
});

// Register in mounted(); call the returned function in beforeUnmount()
export function onEscape(handler) {
	handlers.push(handler);
	return () => {
		const i = handlers.indexOf(handler);
		if (i !== -1) handlers.splice(i, 1);
	};
}
